import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

/**
 * Formato de sobrancelha: desenho natural ou atual da sobrancelha, em sete
 * formatos. Não há escala clínica: a referência é a prática de design de
 * sobrancelhas e visagismo, que lê o ponto inicial, o arco e a cauda.
 * Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/eyebrow_shape.php.
 */
const imageFor = (position) => `formato-sobrancelha-${position}.png`;

const eyebrowShape = {
  key: 'eyebrow_shape',
  name: 'Formato de sobrancelha',
  description: 'Desenho da sobrancelha pelo início, arco e cauda',
  details: 'Registra o formato da sobrancelha em sete desenhos, da reta à descendente, olhando o ponto inicial, a altura do arco e a direção da cauda. Ajuda a planejar design, henna, micropigmentação ou toxina botulínica e a comparar o antes e o depois do procedimento. Um clique marca o formato do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: VisibilityOutlinedIcon,
  accent: 'pink',
  options: [
    { value: 'straight', label: 'Reta', image: imageFor(1), help: 'Pouco ou nenhum arco, com início e cauda quase na mesma altura.' },
    { value: 'rounded', label: 'Arredondada', image: imageFor(2), help: 'Curva contínua e suave, sem ponto de quebra marcado.' },
    { value: 'soft_arch', label: 'Arqueada suave', image: imageFor(3), help: 'Arco discreto, com o ponto mais alto bem definido e transição delicada.' },
    { value: 'high_arch', label: 'Arqueada alta', caption: 'Angulada', image: imageFor(4), help: 'Arco alto e anguloso, com quebra marcada antes da cauda. Dá um olhar mais expressivo.' },
    { value: 's_shaped', label: 'Em S', image: imageFor(5), help: 'Início levemente curvo para baixo e arco que sobe, formando uma onda.' },
    { value: 'ascending', label: 'Ascendente', image: imageFor(6), help: 'A cauda termina mais alta que o início, em linha que sobe.' },
    { value: 'descending', label: 'Descendente', caption: 'Caída', image: imageFor(7), help: 'A cauda termina abaixo do início. Pode deixar o olhar com aspecto cansado.' },
  ],
};

export default eyebrowShape;
